<header class="fixed-top">
  <patient-ui-portal-header></patient-ui-portal-header>
</header>
<!-- has-orbi-entry arms the page-level clearances for the fixed entry point
     (`orbi-rail-gutter` / `orbi-rail-offset` / `orbi-band-gap` /
     `orbi-band-head` / `orbi-band-row` / `orbi-band-title` / `orbi-band-lead` /
     `orbi-band-flush`, defined in styles.scss). Pages only give the bar room while the agent is actually
     available — Split flag AND identity verified (PCSA-13452) — so a patient who
     never sees the entry point sees no space held or gap left for it either. -->
<section class="main-content-wrapper flex-fill pt-8 pt-lg-9" [class.has-orbi-entry]="orbiAgentAvailable$ | async">
  <ui-modal #emailVerifyModalRef size="md" [headerText]="emailVerifyModalHeaderText" footer="none">
    <div class="custom-modal-body">
      <patient-ui-registration-email-verify
        (emailVerified)="emailVerifiedHandler($event)"
        (signOutSelected)="verifyLogOutHandler()"
        (modalHeaderChanged)="modalHeaderChangedHandler($event)"
      ></patient-ui-registration-email-verify>
    </div>
  </ui-modal>
  <div class="app-toasts-anchor">
    <div class="container-xl d-flex justify-content-end">
      <patient-ui-app-toasts aria-live="polite" aria-atomic="true"></patient-ui-app-toasts>
    </div>
  </div>
  <router-outlet></router-outlet>
  <!-- Orbi AI entry point (PCSA-13157): persistent floating "Ask a question"
       bar. Self-contained — it self-gates on the Split flag, self-hides while
       the panel is open, self-places (top-right desktop / bottom mobile), and
       opens the panel + submits on its own (PCSA-13312). No host wiring needed.

       `fixed` at every breakpoint, so where it sits in this markup does not
       affect where it paints — it keeps 64px clear of the footer by measuring the
       footer's position, not by its place in the flow (PCSA-13312/PCSA-13440).
       It stays AFTER `router-outlet` rather than before it so that
       `router-outlet + *` (styles.scss) keeps selecting the routed page, which
       Angular inserts directly after the outlet element. -->
  <patient-ui-orbi-entry-button></patient-ui-orbi-entry-button>
</section>
<!-- Orbi AI chat panel (PCSA-13158) and all of its wiring. OUTSIDE the content
     wrapper above: the panel is an off-canvas overlay, so it must not sit inside
     the flow it covers. Shared with `PublicLayoutComponent`, which hosts the
     agent on the public-layout pages the agent itself links into (Update
     Insurance) — see `OrbiAgentHostComponent`. -->
<patient-ui-orbi-agent-host></patient-ui-orbi-agent-host>
<footer>
  <patient-ui-portal-footer></patient-ui-portal-footer>
</footer>
<patient-ui-portal-timout-modal (logoutDecision)="handleSession($event)"></patient-ui-portal-timout-modal>
<ng-template #ieNotificationModalRef let-modal>
  <div class="modal-header">
    <h2 ngbAutofocus class="modal-title flex-fill text-center mt-6">
      <span class="alert-icon material-icons-round">warning</span> Browser Not Supported
    </h2>
  </div>
  <div class="modal-body">
    <div class="custom-modal-body">
      <p>
        Internet Explorer is no longer supported. You will be unable to access important features of the site on this browser. We recommend
        using the latest version of Google Chrome or Microsoft Edge.
      </p>
      <p>
        If you're unable to use a different browser, contact Customer Service at 1-800-845-6167, Monday through Friday between 8 am and 8 pm
        EST.
      </p>
    </div>
  </div>
</ng-template>
